module.exports = __webpack_public_path__ + "img/title15.d22812dc.png";